export const TableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: 'Nombres',
                    type: 'text',
                    key: 'full_name',
                },
                {
                    title: 'Institución',
                    type: 'text',
                    key: 'institution',
                },
            ],
            actionObj: {
                title: 'Acción',
                type: 'action',
            }
        }
    },
}